// extracted by mini-css-extract-plugin
module.exports = {"hover_card_container":"HoverCard_hover_card_container__s1uVU"};